import { API_URL } from "@/config";
import axios, { AxiosError } from "axios";

const http = axios.create({ baseURL: API_URL, withCredentials: true });

function pickError(err: unknown): string {
    if (axios.isAxiosError(err)) {
        const d = (err as AxiosError<any>).response?.data;
        return d?.message ?? d?.error ?? err.message ?? "Request failed";
    }
    return err instanceof Error ? err.message : "Request failed";
}

export interface FinanceManagerUser {
    id: number;
    email: string;
    name: string;
    dealer_id: number;
}

export async function loginFinanceManager(email: string, password: string) {
    try {
        const res = await fetch(`${API_URL}/finance/auth/login`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ email, password }),
            credentials: "include",
        });
        if (!res.ok) throw new Error(`Login failed: ${res.status}`);
        return res.json();
    } catch (e) {
        throw new Error(pickError(e));
    }
}

export async function getCurrentFinanceManager(): Promise<FinanceManagerUser | null> {
    try {
        const res = await http.get<{ ok: boolean; manager?: FinanceManagerUser }>(
            "/finance/auth/me",
            { validateStatus: (s) => (s >= 200 && s < 300) || s === 401 }
        );
        return res.status === 401 ? null : res.data.manager ?? null;
    } catch {
        return null;
    }
}

export async function logoutFinanceManager(): Promise<void> {
    try {
        await http.post("/finance/auth/logout");
    } catch (e) {
        throw new Error(pickError(e));
    }
}
